import React from 'react'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import { formatOneDecimal, occupancyTone } from './loadCapacityFormat'
import MachineDetailSection from './MachineDetailSection'

const SiblingRow = ({ sibling, onClick }) => {
  const { t_, i18n } = useSmartTranslation()
  const locale = i18n ? i18n.language : undefined
  const ratio = sibling.utilizationRatioPercent
  const tone = occupancyTone(ratio)
  const label = [sibling.name, sibling.description].filter((part) => part !== null && part !== undefined && part !== '').join(' ')
  return (
    <button
      type='button'
      className='mdd__item mdd__item--row'
      onClick={() => onClick(sibling.deviceId)}
      data-testid={'machine-sibling-' + sibling.deviceId}
    >
      <span>{label}</span>
      <span className={'mdd__ratio mdd__tone--' + tone} data-testid='machine-sibling-ratio' data-tone={tone}>
        {ratio === null || ratio === undefined ? t_('Not available') : `${formatOneDecimal(ratio, locale)} %`}
      </span>
    </button>
  )
}

/**
 * Story 175, CU7 (S97-S100) -- the other eligible machines of each group of this machine, with the
 * utilization ratio of the same window. Sections and rows are painted in the order Sun sent them
 * (RN23/RN58: Jupiter never re-sorts); pressing one opens ITS detail in this same drawer (RN7).
 */
const MachineSiblingGroups = ({ siblingGroups, onMachineClick }) => {
  const { t_ } = useSmartTranslation()
  return (
    <MachineDetailSection
      testId='machine-sibling-groups'
      title={t_('Other machines in the group')}
      caption={t_('move load · click to see its detail')}
    >
      {siblingGroups.length === 0
        ? <div className='mdd__empty'>{t_('This machine does not belong to any group')}</div>
        : siblingGroups.map((group) => (
          <div key={group.deviceGroupId} className='mdd__list' data-testid={'machine-sibling-group-' + group.deviceGroupId}>
            <div className='mdd__subgroup-head'>{group.deviceGroupName}</div>
            {group.devices.map((sibling) => <SiblingRow key={sibling.deviceId} sibling={sibling} onClick={onMachineClick} />)}
          </div>
        ))}
    </MachineDetailSection>
  )
}

export default MachineSiblingGroups
